import { FormattedMessage } from "react-intl";
import { ZeroAddress } from "ethers";

import { ContractFeatures, type IToken } from "@framework/types";
import { Card, List, Typography } from "@dzambalaorg/ui-kit";

import { TokenLendButton } from "../../../../../../components/buttons";
import { StyledToolbar } from "./styled";

export interface ILendTokenPanelProps {
  token: IToken;
}

export const LendTokenPanel = (props: ILendTokenPanelProps) => {
  const { token } = props;

  if (!token.template?.contract?.contractFeatures.includes(ContractFeatures.RENTABLE)) {
    return null;
  }

  return (
    <Card>
      <Card.Content>
        <StyledToolbar disableGutters>
          <Typography variant="h5" component="p">
            <FormattedMessage id="pages.token.tokenUser" />
          </Typography>
        </StyledToolbar>
        <List>{!token.metadata.user || token.metadata.user === ZeroAddress ? "N/A" : token.metadata.user}</List>
      </Card.Content>

      <Card.Footer>
        <TokenLendButton token={token} />
      </Card.Footer>
    </Card>
  );
};
